export default "__VITE_ASSET__CnR2H8bc__"